module.exports = __webpack_public_path__ + "img/icon-step-4.25f923f2.png";